import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Helmet } from "react-helmet-async";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Contact from "../components/Contact";

const DryLeaves = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");

  const products = [
    { id: 101, name: "Rosemary Dry Leaves", img: "/images/rosemary_dry_leaves.jpg" },
  ];

  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>
          Dry Leaves Supplier | Aranya Nutraceuticals
        </title>

        <meta
          name="description"
          content="Premium quality dry leaves supplier in India."
        />

        <meta
          name="keywords"
          content="dry leaves, herbal products, nutraceuticals"
        />

        <meta
          property="og:title"
          content="Dry Leaves Supplier | Aranya Nutraceuticals"
        />

        <meta
          property="og:description"
          content="Premium quality dry leaves supplier in India."
        />

        <meta
          property="og:image"
          content="/images/rosemary_dry_leaves.jpg"
        />
      </Helmet>

      <Navbar />

      <div className="px-4 md:px-10 py-8 md:py-12">

        {/* Heading + Search */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">

          <h2 className="text-xl md:text-2xl font-bold">
            Dry Leaves
          </h2>

          <div className="flex w-full md:w-[400px]">
            <input
              type="text"
              placeholder="Search dry leaves..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full border border-gray-300 rounded-l px-4 py-2 outline-none focus:border-green-600"
            />

            <button className="bg-green-600 text-white px-5 rounded-r hover:bg-green-700">
              Search
            </button>
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">

          {filteredProducts.length > 0 ? (
            filteredProducts.map((product) => (
              <div
                key={product.id}
                className="bg-white rounded shadow p-3"
              >
                <img
                  src={product.img}
                  alt={product.name}
                  loading="lazy"
                  width="300"
                  height="200"
                  className="rounded w-full h-40 md:h-48 object-cover"
                />

                <h3 className="mt-2 font-semibold text-sm md:text-base">
                  {product.name}
                </h3>

                <button
                  onClick={() =>
                    navigate(`/dry-leaves/${product.id}`, {
                      state: product,
                    })
                  }
                  className="mt-2 w-full bg-green-600 text-white py-1 rounded text-sm hover:bg-green-700"
                >
                  More Details
                </button>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-lg">
              No products found.
            </p>
          )}
        </div>
      </div>

      <Contact />
      <Footer />
    </>
  );
};

export default DryLeaves;